import { ApiUrls } from "appConstants/apis";
import { Term } from "models/term/Term";
import { BaseServices } from "./baseServices";

export class TermService extends BaseServices<Term> {
	constructor() {
		super(Term);
	}

	getList(filters: any): any {
		try {
			return super
				.listPaginated(ApiUrls.terms.getList, filters)
				.then((response) => response);
		} catch (error) {
			return undefined;
		}
	}

	async getLatestList() {
		return this.list(ApiUrls.terms.getLatestList).then((response) => response);
	}

	createTerm(data: any) {
		return super
			.create(ApiUrls.terms.create, data)
			.then((response) => response);
	}

	getById(id: string): any {
		try {
			return super.get(ApiUrls.terms.getById(id)).then((response) => response);
		} catch (error) {
			return undefined;
		}
	}

	cancelTerm(id: string) {
		return super.delete(ApiUrls.terms.cancelTerm(id));
	}

	updateDate(id: string, data: any) {
		return super
			.patch(ApiUrls.terms.updateDate(id), data)
			.then((response) => response);
	}
}
